import { Component, OnInit, Input, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';

import { GlobalComponents } from '../global-constants';
import { TranscriptionVersionsModel } from '../../../models/previousEditionsModel/TranscriptionMeetingLocalModel';
import { ModalNotificationComponent } from '../modal-notification/modal-notification.component';
import { TranscriptionService } from './../../../core/services/transcription.service';

@Component({
  selector: 'app-modal-previousEditions',
  templateUrl: './modal-previous-editions.component.html',
  styleUrls: ['./modal-previous-editions.component.scss']
})

export class ModalPreviousEditionsComponent implements OnInit {

  displayedColumns = [
    "Archivo",
    "Editor",
    "Fecha",
    "Acción",
  ];

  @Input() sentenceId:number;
  public transcriptions: Array<TranscriptionVersionsModel> = null;
  public transcriptionSelected: TranscriptionVersionsModel = null;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  obs: Observable<any>;
  dataSource: MatTableDataSource<any>;

  constructor(private dialog: MatDialog,
              private changeDetectorRef: ChangeDetectorRef,
              public dialogRef: MatDialogRef<ModalPreviousEditionsComponent>,
              private transcriptionService: TranscriptionService) { }

  ngOnInit(): void {
    this.prepareData(this.sentenceId);
  }

  async prepareData(sentenceId:number)
  {
    this.transcriptionService.getTranscriptionVersion(sentenceId).subscribe(resp => {
      resp.transcriptions.sort((a, b) => b.version - a.version);

      this.transcriptions = new Array<TranscriptionVersionsModel>();
      resp.transcriptions.forEach(element => {
        this.transcriptions.push({
          Orator: resp.orator,
          SentenceDate: resp.sentenceDate,
          ModifyDate: element.modifyDate,
          ModifyBy: element.modifyBy,
          Version: element.version == 1 ? 'Original' : 'Edición ' + element.version,
          Text: element.text,
          Selected: false,
          TranscriptionId: element.transcriptionId
        });
      })

      this.dataSource = new MatTableDataSource<any>(this.transcriptions);
      this.changeDetectorRef.detectChanges();
      this.dataSource.paginator = this.paginator;
      this.obs = this.dataSource.connect();

    }, (error) => {
      this.notificationModal(GlobalComponents.notSuccess);
    });
  }

  ShowDetails(transcription:TranscriptionVersionsModel)
  {    
    this.transcriptions.forEach(element => {
      
      if(element.TranscriptionId == transcription.TranscriptionId){
        element.Selected = true;
      }
      else{
        element.Selected = false;
      }
    });

    this.transcriptionSelected = transcription;    
  }

  notificationModal(message: string){
    const dialogConfig = new MatDialogConfig();    
    dialogConfig.data = {
      message: message,
      valor:10
    }
    const modalRef = this.dialog.open(ModalNotificationComponent, dialogConfig);
  }
}
